import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class BodyType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getBodyType`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="bodyType">
        <Col componentClass={ControlLabel} sm={5}>
          Body Type *
        </Col>
        <Col sm={7}>
          <select
            className="custom-select"
            onChange={this.props.handleChangeBodyType}
            value={this.props.bodyType}
            id="bodyType"
            required
          >
            <option value="">Please Select</option>
            {this.state.option.map((obj, index) => {
              const counter = index
              return (
                <option
                  value={obj.code}
                  key={counter}
                >{obj.name}</option>
              );
            })}
          </select>
        </Col>
      </FormGroup>
    )
  }
}

BodyType.propTypes = {
  handleChangeBodyType: PropTypes.func,
  bodyType: PropTypes.string
};

export default BodyType;



// WEBPACK FOOTER //
// ./src/app/components/bodyType/BodyType.js